import { TRIGGER_SETTINGS } from "./actions"

const INITIAL_STATE = {
  show: false,
}

export default function settingsTriggerReducer(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case TRIGGER_SETTINGS:
      return { ...state, show: action.show }
    default:
      return state
  }
}
